import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    closure_container: {
        display: 'flex',
        flexDirection: 'column',
        gap: '20px',
        padding: '16px',
        boxSizing: 'border-box',
    },
    period_header: {
        backgroundColor: theme.palette.grey[50],
        padding: '20px',
        borderRadius: '8px',
        border: `2px solid ${theme.palette.secondary.dark}`,
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
        display: 'flex',
        flexDirection: 'column',
        gap: '16px'
    },
    period_info_row: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: '12px'
    },
    period_description: {
        fontSize: '20px',
        fontWeight: 700,
        color: theme.palette.secondary.dark
    },
    period_dates_row: {
        display: 'flex',
        gap: '24px',
        justifyContent: 'space-between',
    },
    dates: {
        display: 'flex',
        gap: '24px',
        alignItems: 'center',
        width: '100%'
    },
    total_container: {
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        padding: '12px 16px',
        backgroundColor: theme.palette.grey[300],
        borderRadius: '6px',
        marginTop: '8px'
    },
    total_label: {
        fontSize: '18px',
        fontWeight: 700,
        color: theme.palette.grey[800],
        textTransform: 'uppercase',
        letterSpacing: '0.5px'
    },
    total_price: {
        fontSize: '24px !important',
        fontWeight: 800,
        color: theme.palette.common.white
    },
    closures_table: {
        display: 'flex',
        flexDirection: 'column',
        gap: '8px'
    },
    table_header: {
        display: 'grid',
        gridTemplateColumns: '2fr 1fr 3fr 30px',
        gap: '12px',
        padding: '12px 16px',
        backgroundColor: theme.palette.secondary.dark,
        borderRadius: '6px',
        color: theme.palette.common.white,
        fontWeight: 700,
        fontSize: '14px',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        '@media (max-width: 768px)': {
            display: 'none'
        }
    },
    header_agency: {
        display: 'flex',
        alignItems: 'center'
    },
    header_amount: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    header_date: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    header_notes: {
        display: 'flex',
        alignItems: 'center'
    },
    elements_container: {
        display: 'flex',
        flexDirection: 'column',
        gap: '8px'
    },
    search_btn: {
        minWidth: '120px'
    }
}));

export {useStyles}
